<template>
  <Loading
    :contentSize="true"
    :state="loading"
  >
    <div class="wrapper">
      <h2>{{ $t("Preferences") }}</h2>

      <h3>{{ $t("Schema") }}</h3>
      <div class="selector">
        <select
          v-model="endpointId"
        >
          <option v-if="endpoints" v-for="( endpointName, endpointId ) of endpoints" :key="endpointId" :value="endpointId">{{ endpointName }}</option>
        </select>
      </div>

       <Button
         v-if="permitted( 'cacheServer' )"
         @click="srvCacheClear()"
         class="button"
       >
          {{ $t( "SrvCacheClear" ) }}
      </Button>

      <template v-if="endpointId">
        <Button
          v-if="permitted( 'cache', endpointId )"
          @click="appCacheClear()"
          class="button"
        >
          {{ $t( "AppCacheClear" ) }}
        </Button>

        <Button
          v-if="permitted( 'schemaExport', endpointId )"
          @click="schemaExport()"
          class="button"
        >
          {{ $t( "SchemaExport" ) }}
        </Button>

        <File
          v-if="permitted( 'schemaImport', endpointId )"

          filters=".ttl"

          @input="schemaImport( $event.el, $event.fn )"

          #default="{ fileName, select }"
        >
          <Button
            class="button"
            @click="select()"
          >
            {{ schemaImportButtonValue }}
          </Button>
        </File>

        <Button
          v-if="permitted( 'openMetadata', endpointId )"
          @click="openMetadataShow()"
          class="button"
        >
          {{ $t( "OpenMetadata" ) }}
        </Button>
      </template>


      <h3>{{ $t("Limit") }}</h3>
      <input
        class="limit"
        :placeholder="$t('limitPH')"

        v-model="limit_"
        @blur="limit_=limit"

        ref="limit"
      />

      <h3>{{ $t("chunkSize") }}</h3>
      <select
        class="chunkSize"
        :placeholder="$t('chunkSize')"

        v-model="chunkSize"
      >
        <option value="500">500</option>
        <option value="1000">1000</option>
      </select>
    </div>


    <Modal
      v-for="modal in modals"
      :key="modal.id"
      :show="modal.show"
      :title="modal.title"
      :acceptButtonText="modal.labelOk || modal.labelOk === '' ? modal.labelOk : $t( 'Ok' )"
      :cancelButtonText="modal.labelCancel || modal.labelCancel === '' ? modal.labelCancel : $t( 'Cancel' )"

      @hided="modalRemove( modal.id )"
      @close="modalEvent( 'close', modal.id )"
      @accept="modalEvent( 'ok', modal.id )"
      @cancel="modalEvent( 'cancel', modal.id )"
    >
      <span v-html="modal.content"></span>
    </Modal>

    <Modal
      :show="$route.name.includes( 'OpenMetadata' )"
      :title="$t('OpenMetadataTitle')"
      :emptyBodyUse="true"
      :acceptButtonText="$t( 'Close' )"
      :cancelButtonText="''"
      :buttons="[]"
      :fixed="true"
      :scrollContent="true"

      class="openMetadataViewModal"

      @close="$refs.omc && $refs.omc.close()"
      @accept="$refs.omc && $refs.omc.close()"
    >
      <router-view
        name="OpenMetadata"
        ref="omc"
      />
    </Modal>
  </Loading>
</template>

<script>

import dates from "@/dates"
import utils from "@/utils"
import config from "@/config"
import api from "@/api"
import ls from "@/ls"

import Icon from "@/components/Icon";
import Button from "@/components/Button";
import File from "@/components/File";
import Loading from "@/components/Loading";
import Modal from "../components/Modal";
import user from "../store/modules/user";

export default {
  name: "pageTable",

  components: {
    Icon,
    Loading,
    Modal,
    Button,
    File
  },

  i18n: {
    messages: {
      ru: {
        Preferences:          "Настройки",
        Schema:               "Модель данных",
        EndpointsRequestErr:  "Ошибка запроса точек",
        AppCacheClear:        "Очистить кэш приложения",
        AppCacheClearSuc:     "Кэш приложения успешно очищен",
        AppCacheClearErr:     "Ошибка очистки кэша приложения",
        SrvCacheClear:        "Очистить кэш сервера",
        SrvCacheClearSuc:     "Кэш сервера успешно очищен",
        SrvCacheClearErr:     "Ошибка очистки кэша сервера",
        SchemaExport:         "Экспорт модели",
        SchemaExportErr:      "Ошибка экспорта модели",
        SchemaImport:         "Импорт модели",
        SchemaImportErr:      "Ошибка импорта модели",
        SchemaImportSucc:     "Модель импортирована успешно",
        Limit:                "Количество элементов на странице",
        limitPH:              "число от 1-50",
        chunkSize:            "Размер порции объектов при импорте/экспорте в Excel",
        OpenMetadata:         "OpenMetadata",
        OpenMetadataTitle:    "Работа с OpenMetadata"
      },

      en: {
        Preferences:          "Preferences",
        Schema:               "Endpoint",
        EndpointsRequestErr:  "Endpoints request error",
        AppCacheClear:        "Reset application cache",
        AppCacheClearSuc:     "Application cache has been reset successfully",
        AppCacheClearErr:     "Application cache reset error",
        SrvCacheClear:        "Reset server cache",
        SrvCacheClearSuc:     "Server cache has been reset successfully",
        SrvCacheClearErr:     "Server cache reset error",
        SchemaExport:         "Data model (TBox) export",
        SchemaExportErr:      "Data model export error",
        SchemaImport:         "Data model (TBox) import",
        SchemaImportErr:      "Data model import error",
        SchemaImportSucc:     "Data model has been imported successfully",
        Limit:                "Data objects list: Items per page",
        limitPH:              "number between 1-50",
        chunkSize:            "Excel import/export portion size",
        OpenMetadata:         "Import schema from OpenMetadata",
        OpenMetadataTitle:    "OpenMetadata integration"
      },

      kz: {
        Preferences:          "Параметрлер",
        Schema:               "Үлгі",
        EndpointsRequestErr:  "Соңғы нүктелерді сұрау қатесі",
        AppCacheClear:        "Қолданба кэшін тазалау",
        AppCacheClearSuc:     "Қолданба кэші сәтті тазартылды",
        AppCacheClearErr:     "Қолданбаның кэшін тазалау қатесі",
        SrvCacheClear:        "Сервер кэші тазартылады",
        SrvCacheClearSuc:     "Сервер кэші сәтті тазартылды",
        SrvCacheClearErr:     "Сервер кэшін тазалау қатесі",
        SchemaExport:         "Модельді экспорттау",
        SchemaExportErr:      "Үлгіні экспорттау қатесі",
        SchemaImport:         "Модельді импорттау",
        SchemaImportErr:      "Үлгіні импорттау қатесі",
        SchemaImportSucc:     "Модель сәтті импортталды",
        Limit:                "Әр беттегі элементтер",
        limitPH:              "саны 1-50 аралығында",
        chunkSize:            "Excel bağdarlamasına ïmporttaw/éksporttaw üşin nısandar sanı",
        OpenMetadata:         "OpenMetadata",
        OpenMetadataTitle:    "OpenMetadata-мен жұмыс істеу"
      }
    }
  },

  data() {
    return {
      loading: true,
      modals: [],
      endpoints: {},
      endpointId: null,

      schemaImportButtonValue: this.$t( "SchemaImport" ),

      limit_: null
    }
  },

  async mounted() {
    this.limit_ = this.limit;

    this.loading = true;
    await this.endpointsGet();
    this.loading = false;
  },

  methods: {
    async endpointsGet() {
      let endpoints = {};

      try {
        const ans = await this.$options.api.post.json(
          "/endpoints",
            {
              clientId: this.clientId
            }
        );

        if ( !ans ) throw new Error( "malformed server answer" );
        if ( ans.error ) throw new Error( ans.error );
        if ( Array.isArray( ans.errors ) && ans.errors.length ) throw new Error( ans.errors.join( "; " ) );
        if ( !( "items" in ans ) ) throw new Error( this.$t( "InvalidServerAnswer" ) + ": " + JSON.encode( ans ) );

        endpoints = ans.items;
      }
      catch ( e ) {
        console.error( "ENDPOINTS REQUEST ERROR: request items is failed with " + e.message, e.stack );
        this.$root.$emit( "notify", { header: this.$t( 'EndpointsRequestErr' ), message: e.message, type: "error" } );
      }

      this.endpoints = endpoints;
    },

    modalOpen( content, ok, title, cancel, labelOk, labelCancel ) {
      const modal = {
        id: utils.uniqueHashGen(),
        content,
        title:  title || null,
        show:   false,
        ok,
        cancel,
        labelOk,
        labelCancel
      };

      this.modals.push( modal );

      this.$nextTick( () => { this.$set( modal, "show", true ); } );
    },
    modalEvent( e, modalId ) {
      const modal = this.modals.find( i => i.id === modalId );
      if ( !modal ) return;

      modal.show = false;

      switch ( e ) {
        case "ok":
          if ( modal.ok ) modal.ok();
        break;

        case "close":
        case "cancel":
          if ( modal.cancel ) modal.cancel();
        break;
      }
    },
    modalRemove( modalId ) {
      const modalI = this.modals.findIndex( i => i.id === modalId );
      if ( modalI >= 0 ) {
        this.modals.splice( modalI, 1 );
      }
    },

    async appCacheClear() {
      this.loading = true;

      const ans = await this.$options.api.post.json(
        "/cache/clear",
        {
          endpoint: this.endpointId,
          clientId: this.clientId
        }
      );

      this.loading = false;

      const suc = ans && ans.status === true;

      if ( suc ) this.$root.$emit( "notify", { message: this.$t( "AppCacheClearSuc" ), type: "info" } );
      else this.$root.$emit( "notify", { message: this.$t( "AppCacheClearErr" ), type: "error" } );
/*
        this.modalOpen(
          this.$t( suc ? "CacheClearSuc" : "CacheClearErr" ),
          undefined,
          undefined,
          undefined,
          this.$t( "Ok" ),
          ""
        );
*/

      return suc;
    },

    async srvCacheClear() {
      this.loading = true;

      try {
        let ans = await this.$options.api.post.json(
          "/cache/srv/clear",
            {
              clientId: this.clientId
            }
        );

        if ( !ans ) throw new Error( "malformed server answer" );
        if ( ans.error ) throw new Error( ans.error );
        if ( Array.isArray( ans.errors ) && ans.errors.length ) throw new Error( ans.errors.join( "; " ) );

        await utils.delay( 3000 ); //wait for 3 secs

        ans = await this.$options.api.post.json(
          "/cache/clear",
          {
            clientId: this.clientId
          }
        );
        if ( !ans || !ans.status ) throw new Error( this.$t( "AppCacheClearErr" ) );

        this.$root.$emit( "notify", { message: this.$t( "SrvCacheClearSuc" ), type: "info" } );
      }
      catch ( e ) {
        console.error( "SERVER CACHE CLEAR ERROR: " + e.message, e.stack );
        this.$root.$emit( "notify", { header: this.$t( 'SrvCacheClearErr' ), message: e.message, type: "error" } );
      }

      this.loading = false;
    },

    async schemaExport() {
      utils.fileDownload(
        api.path2url( "/schema/export" ) + "?endpoint=" + encodeURIComponent( this.endpointId ) + "&clientId=" + encodeURIComponent( this.clientId )
      );
    },

    async schemaImport( inputFileEl, inputFileName ) {
      let data = null;

      if ( inputFileEl && inputFileEl.files && inputFileEl.files.length ) {
        try {
          this.loading = true;

          this.schemaImportButtonValue = inputFileName;

          data = new FormData()
          data.append( "file", inputFileEl.files[0] )

          data.set(
            "params",
            JSON.stringify(
              {
                ...this.queryStd,
                endpoint: this.endpointId,
                clientId: this.clientId
              }
            )
          );

          const ans = await api.rq(
            "POST",
            undefined,
            "json",
            "/schema/import",
            data,
            { dataRaw: true },
            false
          );

          if ( !ans ) throw new Error( this.$t( "InvalidServerAnswer" ) );
          if ( ans.errors && ans.errors.length ) throw new Error( ans.errors.join( "; " ) );

          this.$root.$emit( "notify", { message: this.$t( "file" ) + " " + ( inputFileName ? "\"" + inputFileName + "\" " : "" ) + this.$t( "SchemaImportSucc" ), type: "info" } );
        }
        catch ( e ) {
          data = null;
          console.error( e );
          this.$root.$emit( "notify", { header: this.$t( "SchemaImportErr" ), message: e.message, type: "error" } );
        }

        this.schemaImportButtonValue = this.$t( "SchemaImport" );

        this.loading = false;
      }
    },

    openMetadataShow() {
      this.$router.push( { name: "OpenMetadata", params: { endpoint: this.endpointId } } );
    }
  },

  computed: {
    clientId() {
      return this.$store.getters["user/getClientId"]();
    }
  },

  watch: {
    limit_() {
      if ( this.limit_ == "" ) return;

      const v = parseInt( this.limit_, 10 );
      if ( /^\d+$/.test( this.limit_) && v > 0 && v <= 50 ) this.limit = v;
      else this.limit_ = this.limit;
    }
  }
}
</script>

<style scoped>
.wrapper {
  padding: 1em;
}

.wrapper h2 {
  font-size: 1.5em;
  font-weight: bold;
  margin: 1em 0 2em 0;
  color: #4D4D4D;
}

.wrapper h3 {
  font-weight: bold;
  margin: 2em 0 0.5em 0;
}

.selector {
  position: relative;
  display: inline-block;
  border-radius: 0.2em;
  border: solid 1px #000000;
  padding: 0.25em;
  vertical-align: middle;
  margin-right: 1em;
}
.selector > select {
  width: 9.5em;
  padding: 0.1em 0.2em;
  background-color: transparent;
  border: none;
  font-size: inherit;
  font-size: 1.2em;
}
.selector::after {
  content: "";
  position: absolute;
  width: 1em;
  height: 0.9em;
  right: 0.1em;
  top: 0.5em;
  background-color: #FFFFFF;
  background-image: url(data:image/svg+xml;charset=utf-8,%3Csvg%20version%3D%221.1%22%20viewBox%3D%220%200%2016%208%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0D%0A%20%3Cpath%20d%3D%22m0%200%208%208%208-8z%22%20%2F%3E%0D%0A%3C%2Fsvg%3E);
  background-size: 0.8em auto;
  background-position: 50% 50%;
  background-repeat: no-repeat;
  pointer-events: none;
  font-size: inherit;
  font-size: 1.2em;
}

.button {
  display: block;
  width: 12em;
  margin-top: 1em;
  overflow: hidden;
  text-overflow: ellipsis;
}

.limit {
  font-size: 1.2em;
  padding: 0.3em;
  border-radius: 0.2em;
  border: solid 1px #000000;
  width: 10em;
}

.chunkSize {
  font-size: 1.2em;
  padding: 0.3em;
  border-radius: 0.2em;
  border: solid 1px #000000;
  width: 10em;
}

.openMetadataViewModal::v-deep .container {
  min-width: 32vw !important;
}
</style>
